import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Gets the list of suppliers and they enablement.
 */
export const getSuppliers = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedores/listar`)
})
